<main class="main-wrap-ng">
  <div class="content-blk" [ngStyle]="{'margin-top': userRole == 'SuperAdmin' || userRole == 'CustomerService' ? '60px' : '0'}">
    <div class="container">
      <h5 class="page-title">
        Warehouse inventory holding payments
      </h5>      
    <div class="white-background">
      <div class="srch-flt-rt pull-right">
        <mat-form-field floatLabel="never">
          <mat-label>Search payment</mat-label>
          <input matInput  [(ngModel)]="searchString" ng-model-options="{debounce: 10000}" (change)="fn_searchPayment()">
        </mat-form-field>
      </div>

      <div class="search-results" infiniteScroll
          [infiniteScrollDistance]="6"
          [infiniteScrollThrottle]="100"
          [infiniteScrollDisabled]="isFullListDisplayed"
          (scrolled)="fn_getPaymentList()">
        <div class="sp-admin-list-tbl pro-tble-outer sld-tgl-actn">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th width="5" class="text-center">#</th>
                  <th>User</th>
                  <th>Created Date</th>
                  <th>Amount</th>
                  <th>Payment Id</th>
                  <th>Payment Date</th>
                  <th>Payment Status</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="noRecords">
                  <td colspan="7" class="text-center">
                    No records available
                  </td>
                </tr>
                <tr *ngFor="let item of paymentList; let i=index">
                  <td class="text-center">
                    {{i + 1}}
                  </td>
                  <td>
                    {{item.UserName}}
                  </td>
                  <td>
                    <a class="text-uppercase custm-dsgn">{{item.CreatedDate | date }}</a>
                  </td>
                  <td>
                    {{item.Amount}}
                  </td>
                  <td>
                    <div *ngIf="item.PaymentId">
                      {{item.PaymentId}}
                    </div>
                    <div *ngIf="!item.PaymentId">
                      -
                    </div>
                  </td>
                  <td>
                    <div *ngIf="item.PaymentDate">
                      {{item.PaymentDate | date }}
                    </div>
                    <div *ngIf="!item.PaymentDate">
                      -
                    </div>
                  </td>
                  <td>
                    <div *ngIf="!item.IsPaid && userRole =='StoreAdmin'">
                      <button class="btn btn-sm btn-success special-btn" (click)="fn_Pay(item.Id, item.Amount, item.CreatedDate)">
                        Pay
                      </button>
                    </div>
                    <div *ngIf="item.IsPaid">
                      <strong class="text-success">Paid</strong>
                    </div>
                    <div *ngIf="!item.IsPaid && userRole !='StoreAdmin'">
                      <strong class="text-danger">Not Paid</strong>
                    </div>

                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <app-lazy-loader></app-lazy-loader>
      </div>
    </div>
    </div>
  </div>
</main>

<ng-template #paymentDialog let-data>
  <button mat-icon-button class="close-button" mat-dialog-close="false">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
  <h2 matDialogTitle>Complete payment</h2>
  <mat-dialog-content>
    <div>
      Proceed to pay {{ data.PaymentAmount | currency:'USD':'symbol':'1.0-2'}} for date <b>{{data.PaymentCreatedDate | date }}</b>
    </div>
    <div style="text-align:center" class="paypal-payment">
      <ngx-paypal [config]="payPalConfig"></ngx-paypal>
    </div>
  </mat-dialog-content>
</ng-template>
